import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type LLMNodeType = Node<NodeData, 'custom_llm'>;

export const LLMNode: React.FC<NodeProps<LLMNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const config = data.config as Record<string, unknown>;
  const outputPort = (config.output_port as string) || 'response';
  const provider = config.provider as string;
  const subtitle = provider ? `Provider: ${provider}` : 'Language Model';

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="processing"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Single input handle */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="messages"
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'messages'))
            : undefined
        }
      />
      {/* Single output handle */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id={outputPort}
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
